/**
 * @file TableSkeleton.tsx
 * @description
 * -----------------------------------------------------
 * Componente para el skeleton de una tabla
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-04-10
 * @modified 2025-06-26
 * @author DLTCode
 * @author Ainhoa
 * @author Ismael Benabdellah
 * @copyright © DLTCode
 * @license Private
 * */

"use client";

import { c as _c } from "react/compiler-runtime";
const TableSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <article className="table-skeleton"><section className="table__container"><table className="table"><tbody className="table__body"><tr><td><section className="table__skeleton" /></td></tr></tbody></table></section></article>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default TableSkeleton;